import styled from 'styled-components';
import red from 'sushiweb/tokens/color/red';
import white from 'sushiweb/tokens/color/white';
import grey from 'sushiweb/tokens/color/grey';

// Modal Styles (kept from original)
export const ClickableText = styled.span`
  color: ${red.z400};
  border-bottom: 1px dashed ${red.z400};
  padding-bottom: 1px;
  cursor: pointer;
  font-family: 'Lexend-500';
  font-size: 13px;

  &:hover {
    color: ${red.z500};
    border-bottom-color: ${red.z500};
  }
`;

export const ModalContentContainer = styled.div`
  background: ${white};
  display: flex;
  flex-direction: column;
  max-height: ${props => props.maxHeight || '40vh'};
  min-width: 400px;
  width: 100%;
  border-radius: 12px;
`;

export const ModalHeader = styled.div`
  padding: 16px 20px 12px;
  border-bottom: 1px solid ${grey.z200};
  margin: 0;
  flex-shrink: 0;
`;

export const ModalTitle = styled.h3`
  font-size: 15px;
  font-weight: 500;
  font-family: 'Lexend-500';
  color: ${grey.z900};
  margin: 0;
  padding: 0;
  line-height: 1.4;
`;

export const ModalContent = styled.div`
  flex: 1;
  overflow-y: auto;
  margin: 0;
`;

export const ModalList = styled.ul`
  padding: 0;
  margin: 0;
  list-style: none;
`;

export const ModalListItem = styled.li`
  display: flex;
  align-items: center;
  gap: ${props => props.gap || '12px'};
  padding: 12px 20px;
  border-bottom: ${props => (props.isLast ? '' : `1px solid ${grey.z100}`)};
`;

export const ModalListItemText = styled.div`
  font-size: 13px;
  color: ${grey.z800};
  line-height: 1.4;
`;

export const ModalFooter = styled.div`
  display: flex;
  justify-content: center;
  width: 100%;
  border-top: 1px solid ${grey.z200};
  flex-shrink: 0;
`;

export const ModalCloseButton = styled.button`
  color: ${red.z400};
  border: none;
  background: none;
  cursor: pointer;
  font-size: 13px;
  font-weight: 500;
  font-family: 'Lexend-500';
  padding: 12px 20px;
  display: flex;
  align-items: center;
  justify-content: center;

  &:hover {
    color: ${red.z500};
  }
`;
